<template>
  <div class="study_achievement_report w_d fff">
    <h2 class="title_com">学习成果报告</h2>
    <section class="pd2430">
      <!-- 基本数据 -->
      <h2 class="fs20 mb20">基本数据</h2>
      <el-row class="mb20" :gutter="20">
        <el-col :span="6">
          <el-row
            class="border bdr4"
            style="font-size: 16px; padding: 20px; min-height: 187px"
          >
            <el-col>
              <section class="col-height mb10">
                已交作业/总数：<span class="recommend-label"
                  >{{ baseData.total_work_num }}/{{
                    baseData.total_should_work_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                已交平时作业/总数：<span class="recommend-label"
                  >{{ baseData.usual_work_num }}/{{
                    baseData.usual_should_work_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                已交结业作业/总数：<span class="recommend-label"
                  >{{ baseData.graduation_work_num }}/{{
                    baseData.graduation_should_work_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height">
                已交其他作业/总数：<span class="recommend-label"
                  >{{ baseData.other_work_num }}/{{
                    baseData.other_should_work_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col> </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row
            class="border bdr4"
            style="font-size: 16px; padding: 20px; min-height: 187px"
          >
            <el-col>
              <section class="col-height mb10">
                已交问卷/总数：<span class="recommend-label"
                  >{{ baseData.total_questionnaire_num }}/{{
                    baseData.total_should_questionnaire_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                已交日志/总数：<span class="recommend-label"
                  >{{ baseData.journal_questionnaire_num }}/{{
                    baseData.journal_should_questionnaire_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                已交投票/总数：<span class="recommend-label"
                  >{{ baseData.vote_questionnaire_num }}/{{
                    baseData.vote_should_questionnaire_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                已交评价/总数：<span class="recommend-label"
                  >{{ baseData.evaluate_questionnaire_num }}/{{
                    baseData.evaluate_should_questionnaire_num
                  }}</span
                >
              </section>
            </el-col>
            <el-col>
              <section class="col-height">
                已交普通问卷/总数：<span class="recommend-label"
                  >{{ baseData.common_questionnaire_num }}/{{
                    baseData.common_should_questionnaire_num
                  }}</span
                >
              </section>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row
            class="border bdr4"
            style="font-size: 16px; padding: 20px; min-height: 187px"
          >
            <el-col>
              <section class="col-height mb10">
                资源数：<span class="recommend-label">{{
                  baseData.resourse_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                资源查看/下载率：<span class="recommend-label">{{
                  baseData.resourse_rate
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                自发讨论组数：<span class="recommend-label">{{
                  baseData.discuss_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height">
                自发讨论组发言数：<span class="recommend-label">{{
                  baseData.discuss_speak_num
                }}</span>
              </section>
            </el-col>
            <el-col> </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row
            class="border bdr4"
            style="font-size: 16px; padding: 20px; min-height: 167px"
          >
            <el-col>
              <section class="col-height mb10">
                班级圈帖子数：<span class="recommend-label">{{
                  baseData.class_ring_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                置顶帖子数：<span class="recommend-label">{{
                  baseData.class_ring_top_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                帖子评论数：<span class="recommend-label">{{
                  baseData.class_ring_comment_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height mb10">
                帖子获赞数：<span class="recommend-label">{{
                  baseData.class_ring_like_num
                }}</span>
              </section>
            </el-col>
            <el-col>
              <section class="col-height">
                风采墙采纳数：<span class="recommend-label">{{
                  baseData.class_ring_wall_num
                }}</span>
              </section>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- 作业/问卷提交情况统计 -->
      <div class="satisfaction my_flex mb20">
        <h2 class="fs20">作业/问卷提交情况统计</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="handleAvgExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="postList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          height: '50px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column
          label="任务名称"
          width="170"
          align="center"
          prop="title"
        />
        <el-table-column label="任务分类" align="center" prop="type" />
        <el-table-column label="具体类型" align="center" prop="detail_type" />

        <el-table-column
          label="任务起止时间"
          width="180"
          align="center"
          prop="time"
        />

        <el-table-column label="应交人数" align="center" prop="should_num" />
        <el-table-column label="实交人数" align="center" prop="act_num" />
        <el-table-column
          label="未提交人数"
          align="center"
          prop="no_submit_num"
        />
        <el-table-column label="提交率" align="center" prop="submit_rate" />
        <el-table-column label="操作" align="center" prop="">
          <template slot-scope="scope">
            <!--导出统计    导出答题明细-->
            <span v-if="scope.row.type == '作业'" key="type_zy">
              <el-button
                size="mini"
                type="text"
                @click="handleLimitExport(scope.row)"
                >分条导出</el-button
              >
            </span>
            <span v-if="scope.row.type == '问卷'" key="type_wj">
              <el-button
                size="mini"
                type="text"
                @click="handleExportQuestionnaire(scope.row)"
                >导出统计</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleExportAnswer(scope.row)"
                >导出答题明细</el-button
              >
            </span>

            <!--<el-button size="mini" type="text" @click="handleMergeExport(scope.row)">合并导出</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <!-- 作业/问卷提交情况明细 -->
      <div class="satisfaction my_flex mb20">
        <h2 class="fs20">作业/问卷提交情况明细</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="customAdd"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="commitDetailExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="blanksList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <div v-for="(aitem, aindex) in headerList" :key="aindex">
          <el-table-column
            :label="aitem.c_name"
            align="center"
            :prop="aitem.name"
            show-overflow-tooltip
          />
        </div>
        <el-table-column
          label="操作"
          align="center"
          width="1px"
        ></el-table-column>
      </el-table>
      <!-- 风采墙 -->
      <div class="satisfaction my_flex mb20">
        <h2 class="fs20">风采墙（{{ wallStyleList.length }}）</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="WallStyleExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 列表 -->
      <WallStyleSwiper
        :postList="wallStyleList"
        :srcList="srcList2"
        :playerOptionsList="playerOptionsList2"
        v-if="wallStyleList.length > 0"
      ></WallStyleSwiper>
      <Empty v-else :height="200"></Empty>
      <h2 class="fs20 mgtb20">
        班级圈置顶帖子（{{ classRingPostList.length }}）
      </h2>
      <!-- 班级圈置顶帖子列表 -->
      <section v-if="classRingPostList.length > 0">
        <div
          v-for="(item, index) in classRingPostList"
          :key="index"
          class="class_post_list"
        >
          <PostList
            :detailsMain="item"
            :detailsFile="item.file_list"
            :playerOptionsList="playerOptionsList"
            :srcList="srcList"
            :is_who="2"
            v-on="$listeners"
          ></PostList>
        </div>
      </section>
      <Empty v-else :height="200"></Empty>
      <!-- 自发组织讨论组明细 -->
      <div class="satisfaction my_flex mb20">
        <h2 class="fs20">自发组织讨论组明细</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="discussionDetailExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 自发组织讨论组明细表格 -->
      <el-table
        :data="outcomesList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column
          label="讨论组名称"
          align="center"
          width="180"
          prop="title"
          show-overflow-tooltip
        />
        <el-table-column
          label="讨论主题"
          align="center"
          width="180"
          prop="theme"
          show-overflow-tooltip
        />
        <el-table-column label="发起人" align="center" prop="truename" />
        <el-table-column label="参与人数" align="center" prop="join_num" />
        <el-table-column label="发起时间" align="center" prop="create_time" />
        <el-table-column label="发言数量" align="center" prop="speak_count" />

        <el-table-column label="操作" align="center" prop="">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleDetails(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 自定义表头dialog -->
    <CustomHeaderDialog ref="childCustomHeader"></CustomHeaderDialog>
    <!-- 讨论组详情 -->
    <DiscussDetail ref="detailsRef"></DiscussDetail>
  </div>
</template>

<script>
import {
  StudyAchievementBaseData,
  StudyAchievementCommitDetail,
  StudyAchievementCommitDetailExport,
  StudyAchievementCommitDetailList,
  StudyAchievementCommitDetailListExport,
  StudyAchievementWallStyleList,
  StudyAchievementPostList,
  StudyAchievementDiscussionList,
  StudyAchievementDiscussionListExport,
  StudyAchievementWallStyleExport,
} from "@/api/projectAdministrator";
import {
  ItemizeExport,
  ExportStatistics,
  ExportAnswerDetail,
} from "@/api/tearcher";
import WallStyleSwiper from "@/components/swiper/WallStyleSwiper";
import DiscussDetail from "@/components/dialog/DiscussDetail";
export default {
  data() {
    return {
      baseData: {}, // 基本数据
      postList: [], //作业/问卷提交情况统计
      blanksList: [], //作业/问卷提交情况明细
      headerList: [], //作业/问卷提交情况明细表头
      wallStyleList: [], //学习成果报告风采墙
      srcList: [], //学习成果报告班级圈帖子图片预览数组
      srcList2: [], //学习成果报告风采墙图片预览数组
      playerOptionsList2: [], //学习成果报告风采墙视频配置数组
      playerOptionsList: [], //学习成果报告班级圈帖子视频配置数组
      postSrcList: [], //学习成果报告班级圈帖子图片预览数组
      classRingPostList: [], //学习成果报告风采墙图片预览数组
      outcomesList: [], // 自发组织讨论组明细表格
      class_id: "",
    };
  },
  components: {
    WallStyleSwiper,
    DiscussDetail,
  },
  methods: {
    // 查看
    handleDetails(row) {
      this.$refs.detailsRef.operationDialog(row);
    },
    // 自发组织讨论组明细导出
    discussionDetailExport() {
      if (this.outcomesList.length === 0) {
        this.messageTips("暂无导出数据", "error");
        return false;
      }

      StudyAchievementDiscussionListExport({ class_id: this.class_id }).then(
        (res) => {
          saveAs(res, "自发组织讨论组明细.xls");
        }
      );
    },
    // 风采墙导出
    WallStyleExport() {
      if (this.postList.length === 0) {
        this.messageTips("暂无导出数据", "error");
        return false;
      }
      StudyAchievementWallStyleExport({ class_id: this.class_id }).then(
        (res) => {
          if (Number(res.error_code) === 200 && res.data) {
            this.downloadFile(res.data.path);
          } else {
            this.msgError("暂无导出数据");
          }
        }
      );
    },
    // 作业/问卷提交情况明细
    getBlanksList() {
      StudyAchievementCommitDetailList({ class_id: this.class_id }).then(
        (res) => {
          let oSum = [];
          for (let o of res.data.header) {
            if (o.is_show === 1) {
              oSum.push(o);
            }
          }
          this.headerList = oSum;
          this.blanksList = res.data.list.slice(0,10);
        }
      );
    },
    // 作业/问卷提交情况明细导出
    commitDetailExport() {
      StudyAchievementCommitDetailListExport({ class_id: this.class_id }).then(
        (res) => {
          saveAs(res, "作业和问卷提交情况明细.xls");
        }
      );
    },
    // 作业/问卷提交情况明细自定义表头
    customAdd() {
      this.$refs.childCustomHeader.operationDialog(
        this.class_id,
        9,
        this.getBlanksList,
        ""
      );
    },
    // 导出答题明细
    handleExportAnswer(row) {
      ExportAnswerDetail({ id: row.id }).then((res) => {
        saveAs(res, "答题明细.xls");
      });
    },
    // 导出统计
    handleExportQuestionnaire(row) {
      let zipData = ExportStatistics({ id: row.id });
      zipData
        .then((res) => {
          saveAs(res, "导出统计_" + row.title + ".docx");
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    // 分条导出
    async handleLimitExport(row) {
      let zipData = await ItemizeExport({ id: row.id });
      if (Number(zipData.error_code) === 200 && zipData.data) {
        this.downloadFile(zipData.data);
      } else {
        this.messageTips("暂无导出数据", "error");
      }
    },
    // 作业/问卷提交情况统计导出
    handleAvgExport() {
      if (this.postList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }
      StudyAchievementCommitDetailExport({ class_id: this.class_id }).then(
        (res) => {
          saveAs(res, "作业/问卷提交情况统计.xls");
        }
      );
    },
    // 过滤文件
    filterFile(arr, is_who) {
      arr.map((item2) => {
        if (this.isFileExtVideo(item2.ext)) {
          let datas = {
            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: "zh-CN",
            aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
              {
                type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                src: item2.savepath, //url地址
              },
            ],
            // width: document.documentElement.clientWidth, //播放器宽度
            height: 200, //播放器
            notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true,
              durationDisplay: true,
              remainingTimeDisplay: false,
              // fullscreenToggle: false //全屏按钮
            },
            responsive: true, // 启用响应模式
          };
          if (is_who == 1) {
            this.playerOptionsList[item2.id] = datas;
          } else {
            this.playerOptionsList2[item2.id] = datas;
          }
        } else {
          if (is_who == 1) {
            this.srcList.push(item2.savepath);
          } else {
            this.srcList2.push(item2.savepath);
          }
        }
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 学习成果报告基本数据
      StudyAchievementBaseData({ class_id: this.class_id }).then((res) => {
        this.baseData = res.data;
      });
      // 作业/问卷提交情况统计列表
      StudyAchievementCommitDetail({
        class_id: this.class_id,
      }).then((res) => {
        this.postList = res.data.slice(0,10);
      });
      // 作业/问卷提交情况明细
      this.getBlanksList();
      // 学习成果报告风采墙
      StudyAchievementWallStyleList({
        class_id: this.class_id,
        limit: 20,
        page: 1,
      }).then((res) => {
        this.wallStyleList = res.data.list;
        this.filterFile(this.wallStyleList, 2);
      });
      // 学习成果报告班级圈置顶帖子
      StudyAchievementPostList({
        class_id: this.class_id,
      }).then((res) => {
        this.classRingPostList = res.data;
        this.classRingPostList.map((item) => {
          this.filterFile(item.file_list, 1);
        });
      });
      // 自发组织讨论组明细
      StudyAchievementDiscussionList({
        class_id: this.class_id,
      }).then((res) => {
        this.outcomesList = res.data;
        console.log(this.outcomesList, "this.outcomesList ");
      });
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.study_achievement_report {
  .class_post_list {
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    &:last-child {
      /* border-bottom: none; */
    }
  }
}
</style>